<template>
  <v-container fluid>
    <v-checkbox v-model="checkAll" :label="`Выбрать все`" dense></v-checkbox>
    <v-row>
      <v-col class="py-0" cols="12" sm="4" v-for="predict in model" v-bind:key="predict.value">
        <v-checkbox v-model="predict.checked" :label="getLable(predict.value)"></v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "SelectedDomainList",
  props: {
    model: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  data: function() {
    return {};
  },
  computed: {
    checkAll: {
      get: function() {
        if (this.model.length) {
          return !this.model.some(d => !d.checked);
        }

        return false;
      },
      set: function(newVal) {
        this.model.forEach(d => (d.checked = newVal));
      }
    }
  },
  methods: {
    getLable(value) {
      return `${value} мин [${value / 60} ч]`;
    }
  }
};
</script>